<div class="row payroll-instructor-summary-row payroll-row align-items-center">
    <div class="col-5">
        <div class="row">
            <div class="col-3">{{ summaryItem.instructorName || 'No instructor' }}<br> {{ 'PayrollReport.AdpIdHeader' | translate }}: {{ summaryItem.instructorAdpId || '-' }}</div>
        </div>
    </div>
    <div class="col-7">
        <div class="row">
            <div class="col-4"></div>
            <div class="col-3"></div>
            <div class="col-3 text-center">Total Hours:<br>{{summaryItem.totalHours | number:'1.1-1'}}</div>
            <div class="col-2 p-0 text-center">Total Cost:<br>{{summaryItem.totalCost | currency }}</div>
        </div>
    </div>
</div>
<div *ngFor="let categorySummaryItem of summaryItem.categories">
    <div class="row payroll-category-summary-row payroll-row align-items-center">
        <div class="col-5">
            <div class="row align-items-center">
                <div class="col-3"></div>
                <div class="col-3">{{categorySummaryItem.jobCostCode}}<br>{{categorySummaryItem.jobCostCodeDescription}}
                </div>
                <div class="col-4">{{categorySummaryItem.categoryName}}</div>
                <div class="col-2">{{categorySummaryItem.hourlyRate | currency }}</div>
            </div>
        </div>
        <div class="col-7">
            <div class="row">
                <div class="col-4"></div>
                <div class="col-3"></div>
                <div class="col-3 text-center">Total Hours:<br>{{categorySummaryItem.totalHours | number:'1.1-1'}}</div>
                <div class="col-2 text-center p-0">Total Cost:<br>{{categorySummaryItem.totalCost | currency }}</div>
            </div>
        </div>
    </div>
    <div class="row payroll-row align-items-center" *ngFor="let classItem of categorySummaryItem.classes">
        <div class="col-5"><span class="payroll-substitution" *ngIf="classItem.substitution">(sub)</span></div>
        <div class="col-7">
            <div class="row align-items-center">
                <div class="col-4">
                    <img *ngIf="classItem.cancelled" src="./assets/ic_cancelled.svg" width="20" height="20"
                        alt="No attendance" tooltip="{{ 'PayrollReport.CancelledClass' | translate }}"
                        placement="bottom" />
                    <img *ngIf="!attendanceProvided(classItem)" src="./assets/ic_attendance.svg" width="20" height="20"
                        alt="No attendance" tooltip="{{ 'PayrollReport.ZeroAttendance' | translate }}"
                        placement="bottom" />
                    {{ classItem.className }}
                </div>
                <div class="col-3">{{ classItem.bcDate | bcDate: 'MMM DD' }}, {{ classItem.startTime | timeDisplay }}</div>
                <div class="col-1 text-right pr-1">{{ classItem.actualLengthOfClass }}</div>
                <div class="col-1"></div>
                <div class="col-1 text-left pl-1">{{ classItem.billableLengthOfClass }}</div>
                <div class="col-2 text-center">{{ classItem.cost | currency }}</div>
            </div>
        </div>
    </div>
</div>
